import {createContext} from "react";

const ParamsContext = createContext();
export default ParamsContext;
